import BooleanDisplayFilter from './BooleanDisplayFilter';
import PgbaDateFilter from './PgbaDateFilter';
import PgbaAddressFilter from './PgbaAddressFilter';
import MaskedSSNFilter from './MaskedSSNFilter';
import ResourceBundleFilter from './ResourceBundleFilter';

export default {
    install(Vue) {
        Vue.filter('booleanDisplay', BooleanDisplayFilter);
        Vue.filter('pgbaAddress', PgbaAddressFilter);
        Vue.filter('pgbaDate', PgbaDateFilter);
        Vue.filter('resourceKey', ResourceBundleFilter);
        Vue.filter('maskedSSN', MaskedSSNFilter);
    }
};
